import React from 'react';
import { IconInterface } from './Icon.interface';

const Bash: React.FC<IconInterface> = ({size = 24}) => {
	return (
		<span className='i-icon'>
			<svg xmlns="http://www.w3.org/2000/svg"  viewBox={'0 0 48 48'} width={size} height={size} fill="none">
				<path fill="currentColor" d="M 2.84375 3 C 1.273438 3 0 4.273438 0 5.84375 L 0 10 L 50 10 L 50 5.84375 C 50 4.273438 48.726563 3 47.15625 3 Z M 0 12 L 0 46 C 0 46.554688 0.449219 47 1 47 L 49 47 C 49.554688 47 50 46.554688 50 46 L 50 12 Z M 15.09375 19.96875 C 15.351563 19.972656 15.589844 20.050781 15.78125 20.25 L 22.40625 27.0625 L 15.625 33.6875 C 15.429688 33.875 15.191406 33.96875 14.9375 33.96875 C 14.675781 33.96875 14.414063 33.855469 14.21875 33.65625 C 13.832031 33.261719 13.824219 32.636719 14.21875 32.25 L 19.59375 27.03125 L 14.375 21.65625 C 13.988281 21.261719 13.980469 20.636719 14.375 20.25 C 14.574219 20.054688 14.835938 19.964844 15.09375 19.96875 Z M 23 32 L 36 32 C 36.554688 32 37 32.445313 37 33 C 37 33.554688 36.554688 34 36 34 L 23 34 C 22.449219 34 22 33.554688 22 33 C 22 32.445313 22.449219 32 23 32 Z" />
			</svg>
		</span>
	);
}

export default Bash;
